import { useState } from 'react';

const faqs = [
  {
    q: 'Who provides home improvement services near me?',
    a: 'Culp Home Improvement provides residential remodeling services including kitchen renovations, bathroom upgrades, and general home improvements. They serve local homeowners with a focus on quality craftsmanship, reliable execution, and long-lasting results that improve both functionality and overall property value.',
  },
  {
    q: 'How much does home improvement cost?',
    a: 'Home improvement costs vary based on project size, materials, and complexity. Smaller upgrades are more affordable, while full remodels require a larger investment. Culp Home Improvement provides clear, upfront estimates so homeowners understand pricing and scope before any work begins.',
  },
  {
    q: 'How long do remodeling projects take?',
    a: 'Project timelines depend on the size and scope of work. Smaller jobs may take a few days, while full renovations can take several weeks. Culp Home Improvement sets expectations early and works efficiently to complete projects on time with minimal disruption.',
  },
  {
    q: 'Is Culp Home Improvement licensed and insured?',
    a: 'Yes. All work is licensed, bonded, and insured. The owner is present on every job, ensuring quality control and direct accountability from start to finish. Homeowners can trust that their project is in experienced, professional hands.',
  },
  {
    q: 'What areas does Culp Home Improvement serve?',
    a: 'Culp Home Improvement serves Johnston, Des Moines, Ankeny, Urbandale, Clive, West Des Moines, Grimes, Waukee, Adel, Altoona, and surrounding communities throughout the greater Des Moines metro area in Iowa.',
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section className="py-28 bg-white">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="mb-16">
          <p
            className="text-[#B8956A] text-[11px] font-bold uppercase tracking-[0.22em] mb-5"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            FAQ
          </p>
          <h2
            className="text-4xl md:text-5xl font-bold text-[#1A1A1A] leading-tight"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Common Questions
          </h2>
          <p
            className="text-[#777] text-base mt-4 max-w-lg"
            style={{ fontFamily: 'Lora, serif' }}
          >
            Answers to the most common questions about our home improvement and remodeling services.
          </p>
        </div>

        <div className="divide-y divide-[#EDEAE5]">
          {faqs.map((faq, i) => (
            <div key={i}>
              <button
                className="w-full flex items-center justify-between py-7 text-left cursor-pointer group"
                onClick={() => setOpen(open === i ? null : i)}
              >
                <h4
                  className="text-base md:text-lg font-semibold text-[#1A1A1A] group-hover:text-[#B8956A] transition-colors duration-200 pr-8 leading-snug"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  <a href={`#faq-${i}`} onClick={(e) => e.preventDefault()}>{faq.q}</a>
                </h4>
                <div
                  className={`w-9 h-9 flex items-center justify-center flex-shrink-0 rounded-full border transition-all duration-300 ${
                    open === i
                      ? 'bg-[#B8956A] border-[#B8956A]'
                      : 'border-[#E0D8D0] group-hover:border-[#B8956A]'
                  }`}
                >
                  <i
                    className={`text-lg transition-all duration-300 ${
                      open === i ? 'ri-subtract-line text-white' : 'ri-add-line text-[#B8956A]'
                    }`}
                  ></i>
                </div>
              </button>
              <div
                id={`faq-${i}`}
                className={`overflow-hidden transition-all duration-500 ${
                  open === i ? 'max-h-64 pb-7' : 'max-h-0'
                }`}
              >
                <p
                  className="text-[#666] text-base leading-relaxed"
                  style={{ fontFamily: 'Lora, serif' }}
                >
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
